import { InjectionToken } from '@angular/core';
import { AdminState, adminReducer } from '@core/store/reducers/admin.reducer';
import { NotificationsState, notificationsReducer } from '@core/store/reducers/notifications.reducer';
import { ResultsState, resultsReducer } from '@core/store/reducers/results.reducer';
import { UsersState, usersReducer } from '@core/store/reducers/users.reducer';
import { RouterReducerState, routerReducer } from '@ngrx/router-store';
import { Action, ActionReducerMap } from '@ngrx/store';
import { OrdersState, ordersReducer } from './orders.reducer';
import { OrganizationsState, organizationsReducer } from './organizations.reducer';
import { SpinnerState, spinnersReducer } from './spinners.reducer';
import { SideBarNotificationState, sideBarNotificationStateReducer } from './side-bar-notification.reducer';
export interface AppState {
  adminState: AdminState;
  notificationsState: NotificationsState;
  ordersState: OrdersState;
  organizationsState: OrganizationsState;
  resultsState: ResultsState;
  usersState: UsersState;
  routerState: RouterReducerState<any>;
  spinnerState: SpinnerState;
  sideBarNotificationState: SideBarNotificationState;
}

export const REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<AppState, Action>>('Registered Reducers', {
    factory: () => ({
      adminState: adminReducer,
      notificationsState: notificationsReducer,
      ordersState: ordersReducer,
      organizationsState: organizationsReducer,
      resultsState: resultsReducer,
      usersState: usersReducer,
      routerState: routerReducer,
      spinnerState: spinnersReducer,
      sideBarNotificationState: sideBarNotificationStateReducer
    }),
  });
